import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { APP_URL } from '../../../config';

function* billingSubscriptionUpgrade({ payload: { onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.billing.subscription.upgrade,
      data: {
        success_url: `${APP_URL}billing?tab=subscriptions`,
        cancel_url: `${APP_URL}billing?tab=subscriptions`
      }
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.billingSubscriptionUpgradeDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.billingSubscriptionUpgradeFailed,
      handledErrors,
      endpoint: api.billing.subscription.upgrade.url
    });
  }
}

export const billingSubscriptionUpgradeSaga = takeEvery(types.BILLING_SUBSCRIPTION_UPGRADE_REQUEST, billingSubscriptionUpgrade);